export default "__VITE_ASSET__1fdd8186__"